export var abbreviations = {
    АО: 'автономный округ',
    Аобл: 'автономная область',
    Респ: 'Республика',
    Чувашия: 'Чувашская Республика',
    г: 'город',
    'г.ф.з.': 'город федерального значения',
    край: 'край',
    обл: 'область',
    округ: 'округ',
    'вн.тер.г.': 'внутригородская территория',
    'г.о.': 'городской округ',
    'м.р-н': 'муниципальный район',
    'р-н': 'район',
    тер: 'территория',
    у: 'улус',
    волость: 'волость',
    дп: 'дачный поселок',
    кп: 'курортный поселок',
    массив: 'массив',
    п: 'поселок',
    'п/о': 'почтовое отделение',
    пгт: 'поселок городского типа',
    рп: 'рабочий поселок',
    'с/а': 'сельская администрация',
    'с/мо': 'сельское муницип.образование',
    'с/о': 'сельский округ',
    'с/п': 'сельское поселение',
    'с/с': 'сельсовет',
    аал: 'аал',
    автодорога: 'автодорога',
    арбан: 'арбан',
    аул: 'аул',
    высел: 'выселки(ок)',
    городок: 'городок',
    гп: 'городской поселок',
    д: 'деревня',
    'ж/д_будка': 'железнодорожная будка',
    'ж/д_казарм': 'железнодорожная казарма',
    'ж/д_оп': 'ж/д останов. (обгонный) пункт',
    'ж/д_платф': 'железнодорожная платформа',
    'ж/д_пост': 'железнодорожный пост',
    'ж/д_рзд': 'железнодорожный разъезд',
    'ж/д_ст': 'железнодорожная станция',
    жилзона: 'жилая зона',
    жилрайон: 'жилой район',
    заимка: 'заимка',
    казарма: 'казарма',
    'кв-л': 'квартал',
    кордон: 'кордон',
    лпх: 'леспромхоз',
    м: 'местечко',
    мкр: 'микрорайон',
    нп: 'населенный пункт',
    остров: 'остров',
    'п/р': 'промышленный район',
    'п/ст': 'поселок и(при) станция(и)',
    погост: 'погост',
    починок: 'починок',
    промзона: 'промышленная зона',
    рзд: 'разъезд',
    с: 'село',
    сл: 'слобода',
    снт: 'садовое неком-е товарищество',
    ст: 'станция',
    'ст-ца': 'станица',
    х: 'хутор',
    'а/я': 'абонентский ящик',
    аллея: 'аллея',
    'б-р': 'бульвар',
    балка: 'балка',
    берег: 'берег',
    бугор: 'бугор',
    вал: 'вал',
    'взв.': 'взвоз',
    въезд: 'въезд',
    гск: 'гаражно-строительный кооп.',
    днп: 'дачное неком-е партнерство',
    дор: 'дорога',
    'ж/р': 'жилой район',
    жт: 'животноводческая точка',
    заезд: 'заезд',
    зона: 'зона',
    км: 'километр',
    кольцо: 'кольцо',
    коса: 'коса',
    линия: 'линия',
    маяк: 'маяк',
    'мгстр.': 'магистраль',
    местность: 'местность',
    'месторожд.': 'месторождение',
    мост: 'мост',
    'н/п': 'некоммерческое партнерство',
    наб: 'набережная',
    'п-к': 'починок',
    парк: 'парк',
    пер: 'переулок',
    переезд: 'переезд',
    пл: 'площадь',
    'пл-ка': 'площадка',
    платф: 'платформа',
    полустанок: 'полустанок',
    порт: 'порт',
    'пр-кт': 'проспект',
    проезд: 'проезд',
    просек: 'просек',
    просека: 'просека',
    проселок: 'проселок',
    проулок: 'проулок',
    ряд: 'ряд(ы)',
    ряды: 'ряды',
    'с/т': 'садовое товарищество',
    сад: 'сад',
    'сзд.': 'съезд',
    сквер: 'сквер',
    спуск: 'спуск',
    стр: 'строение',
    'тер.': 'территория',
    'тер. ГСК': 'территория ГСК',
    'тер. ДНО': 'территория ДНО',
    'тер. ДНП': 'территория ДНП',
    'тер. ДНТ': 'территория ДНТ',
    'тер. ДПК': 'территория ДПК',
    'тер. ОНО': 'территория ОНО',
    'тер. ОНП': 'территория ОНП',
    'тер. ОНТ': 'территория ОНТ',
    'тер. ОПК': 'территория ОПК',
    'тер. СНО': 'территория СНО',
    'тер. СНП': 'территория СНП',
    'тер. СНТ': 'территория СНТ',
    'тер. СПК': 'территория СПК',
    'тер. ТСН': 'территория ТСН',
    'тер.ф.х.': 'территория ФХ',
    тракт: 'тракт',
    туп: 'тупик',
    ул: 'улица',
    'ус.': 'усадьба',
    'уч-к': 'участок',
    'ф/х': 'фермерское хозяйство',
    ферма: 'ферма',
    ш: 'шоссе',
    'ю.': 'юрты',
    ДОМ: 'дом',
    ОНС: 'объект незав. строительства',
    'влд.': 'владение',
    'двлд.': 'домовладение',
    'зд.': 'здание',
    'к.': 'корпус',
    'кот.': 'котельная',
    'пав.': 'павильон',
    'соор.': 'сооружение',
    шахта: 'шахта',
    // types from https://api.kontur.ru/fias/v1/addresses/types
    'а.обл.': 'автономная область',
    'а.окр.': 'автономный округ',
    'г.': 'город',
    'обл.': 'область',
    'респ.': 'республика',
    'пос.': 'поселение',
    'у.': 'улус',
    'м.о.': 'муниципальный округ',
    'вн.р-н': 'внутригородской район',
    'г.п.': 'городское поселение',
    'межсел.тер.': 'межселенная территория',
    'с.п.': 'сельское поселение',
    'пгт.': 'поселок городского типа',
    'г-к': 'городок',
    'дп.': 'дачный поселок',
    'ж/д б-ка': 'железнодорожная будка',
    'ж/д в-ка': 'железнодорожная ветка',
    'ж/д к-ма': 'железнодорожная казарма',
    'ж/д пл-ма': 'железнодорожная платформа',
    'ж/д пл-ка': 'железнодорожная площадка',
    'ж/д бл-ст': 'железнодорожный блокпост',
    'ж/д к-т': 'железнодорожный комбинат',
    'ж/д о.п.': 'железнодорожный остановочный пункт',
    'ж/д п.п.': 'железнодорожный путевой пост',
    'зим.': 'зимовье',
    'киш.': 'кишлак',
    'нп.': 'населенный пункт',
    'пл.р-н': 'планировочный район',
    'п. ж/д ст.': 'поселок при железнодорожной станции',
    'п. ст.': 'поселок при станции (поселок станции)',
    'пос.рзд': 'поселок разъезда',
    сп: 'сельский поселок',
    'сп.': 'сельский поселок',
    'ал.': 'аллея',
    'б-г': 'берег',
    'взд.': 'въезд',
    'д.': 'деревня',
    'дор.': 'дорога',
    'ж/д ст.': 'железнодорожная станция',
    'ж/д рзд.': 'железнодорожный разъезд',
    'ззд.': 'заезд',
    'к-цо': 'кольцо',
    'лн.': 'линия',
    'м-ко': 'местечко',
    'мр.': 'месторождение',
    'мкр.': 'микрорайон',
    'наб.': 'набережная',
    'ост-в': 'остров',
    'пер-д': 'переезд',
    'пер.': 'переулок',
    'платф.': 'платформа',
    'пл.': 'площадь',
    'п.': 'поселок',
    'пр-д': 'проезд',
    'пр-к': 'просек',
    'пр-ка': 'просека',
    'пр-лок': 'проселок',
    'проул.': 'проулок',
    'рзд.': 'разъезд',
    'с.': 'село',
    'с-р': 'сквер',
    'сл.': 'слобода',
    'с-к': 'спуск',
    'ст.': 'станция',
    'стр.': 'строение',
    'тер. ПК': 'территория пк',
    'тер.СОСН': 'территория сосн',
    'тер. ТСЖ': 'территория тсж',
    'туп.': 'тупик',
    'ул.': 'улица',
    'х.': 'хутор',
    'ш.': 'шоссе',
    'з/у': 'земельный участок',
    'м/м': 'машино-место',
    // missing types from http://base.garant.ru/71249284/#block_1000
    'г.о. вн.д.': 'городской округ с внутригородским делением',
    'СП.': 'сельский поселок',
    'рп.': 'рабочий поселок',
    'кп.': 'курортный поселок',
    'гп.': 'городской поселок',
    'в-ки': 'выселки',
    'з-ка': 'заимка',
    'тер. СОСН': 'Территория СОСН',
    'г-ж': 'гараж',
    'кв.': 'квартира',
    'ком.': 'комната',
    'подв.': 'подвал',
    'п-б': 'погреб',
    офис: 'офис',
    'помещ.': 'помещение',
    'раб.уч.': 'рабочий участок',
    'скл.': 'склад',
    'торг.зал': 'торговый зал',
    цех: 'цех',
};
